module.exports = __webpack_public_path__ + "static/media/mainimg-02.5ce99bef.png";